export const writings = [
  {
    id: 1,
    title: "Why Ethical AI Must Act, Not Just Talk",
    publication: "CloudTweaks",
    url: "https://cloudtweaks.com/2026/02/ethical-ai-actionai-ceo-miriam-haart/",
  },
  // {
  //   id: 1,
  //   title: "How ActionAI's Miriam Haart is shaping the future of reliable AI",
  //   publication: "Jerusalem Post",
  //   url: "https://www.jpost.com/podcast/article-892143",
  // },
  {
    id: 2,
    title: "What Young Activists Believe",
    publication: "Middle East Forum",
    url: "https://www.meforum.org/mef-observer/why-young-activists-believe-palestinian-freedom-requires-israeli-destruction",
  },
  {
    id: 3,
    title: "A Rainbow and Its Ephemeral Beauty",
    publication: "Substack",
    url: "https://substack.com/@haart/p-102530574",
  },
  {
    id: 4,
    title: "Pride or prejudice? Antisemitism in queer spaces",
    publication: "Jerusalem Post",
    url: "https://www.jpost.com/diaspora/antisemitism/article-856875",
  },
  {
    id: 5,
    title: "Why I'm anti anti-Zionism",
    publication: "Stanford Daily",
    url: "https://stanforddaily.com/2025/04/23/why-im-anti-anti-zionism/",
  },
  {
    id: 6,
    title: "I will not be overturned: An NFT collection to combat the removal of Roe V. Wade",
    publication: "MsMagazine",
    url: "https://msmagazine.com/2022/06/15/my-unorthodox-life-miriam-haart-nft-abortion-roe-v-wade-jewish/",
  },
  {
    id: 7,
    title: "Changing One Word Can Change Everything",
    publication: "Rebel Girls",
    url: "https://www.rebelgirls.com/blog/miriam-haart-best-advice-growth-mindset"
  }
];
